import request from '../utils/request'
import { ParamsProps, ReturnType } from './types'

const getByKey = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `general-settings/key/${args?.id}`,
      method: 'get',
      authorization: false,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: args?.state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const getByGroup = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `general-settings/group/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: args?.state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `general-settings`,
      method: 'post',
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Created Successfully',
        store: {
          action: 'set',
          key: args?.state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `general-settings/${args?.id}`,
      method: 'patch',
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Updated Successfully',
        store: {
          action: 'update',
          key: args?.state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `general-settings/${args?.id}`,
      method: 'delete',
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Deleted Successfully',
        store: {
          action: 'remove',
          key: args?.state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

export default {
  getByKey,
  getByGroup,
  create,
  update,
  remove,
}
